// src/admin/shell/useSidebarCollapsed.ts
// Persisted sidebar collapsed/expanded preference. Mirrors useTweaks' shape so
// any component in the tree can read or toggle without a context provider.
import { useEffect, useState } from 'react';

const KEY = 'thandizo.admin.sidebar';
const EVT = 'thandizo:sidebar-changed';

function read(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

function write(collapsed: boolean): void {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(KEY, collapsed ? '1' : '0');
  window.dispatchEvent(new CustomEvent<boolean>(EVT, { detail: collapsed }));
}

export function useSidebarCollapsed() {
  const [collapsed, setCollapsed] = useState<boolean>(read);

  useEffect(() => {
    const onChange = (e: Event) => {
      const detail = (e as CustomEvent<boolean>).detail;
      setCollapsed(detail);
    };
    window.addEventListener(EVT, onChange);
    return () => window.removeEventListener(EVT, onChange);
  }, []);

  return {
    collapsed,
    toggle: () => write(!collapsed),
    setCollapsed: (v: boolean) => write(v),
  };
}
